// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateTime } from 'luxon';
import { z } from 'zod';

// Upper bound is end-of-today in the user's local timezone. Server-side the
// tolerance is now + 24 hours so clients in forward-of-UTC zones can submit
// a local end-of-day without tripping the BE validator. Keeping the FE rule
// end-of-local-day keeps the UX honest about what "today" means.
export const markInvoiceAsSentFormSchema = z.object({
  sentAt: z
    .custom<DateTime>((value) => DateTime.isDateTime(value) && value.isValid, {
      message: 'A sent-at date and time is required',
    })
    .refine(
      (value) => value.toMillis() <= DateTime.local().endOf('day').toMillis(),
      { message: 'Sent at cannot be in the future' }
    ),
});

export type MarkInvoiceAsSentFormData = z.infer<
  typeof markInvoiceAsSentFormSchema
>;
